import React from 'react'
import { ReverCard } from '@itsrever/design-system'
import { NoData } from '@/ui/shared'
import { DailyReturnsChart } from '../daily-returns-chart'

interface LineChartProps {
  title: string
  subtitle?: string
  values: number[]
  days: string[]
}

const LineChartComponent: React.FC<LineChartProps> = ({
  title,
  subtitle,
  values,
  days
}) => {
  return (
    <ReverCard
      fullWidth
      sx={{ backgroundColor: 'rgb(30, 41, 59)', marginTop: '1rem' }}
    >
      <div className="w-full px-8 pt-8 text-[#eeeeee]">
        <p className="text-xl">{title}</p>
        {subtitle ? <p className="text-[#aedcff]">{subtitle}</p> : null}
      </div>
      <div className="h-[280px]">
        {values.length ? (
          <DailyReturnsChart variant="dark" values={values} days={days} />
        ) : (
          <NoData />
        )}
      </div>
    </ReverCard>
  )
}

export default LineChartComponent
